import CampaignCard from "./campaignCard";
import { useCampaignCategories, useCampaignList, useFilterCampaign } from "../../reuseableEffects";
import { useEffect, useState } from "react";
import Button from "../../../components/button";
import filter from "../../../assets/icons/whiteFilterIcon.svg"
import Input from "../../../components/input";
import { useSelector } from "react-redux";
import Spinner from "../../../components/Spinners/Spinner";
import close from "../../../assets/icons/close.svg";

const CampaignList = ({cardLayout}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [filteredCampaigns, setFilteredCampaigns] = useState([]);
  const [searchCampaign, setSearchCampaign] = useState("");

  const openModal = () => {
    setIsModalOpen(true);
  }

  const closeModal = () => {
    setIsModalOpen(false);
  }
  
  const campaignList = useCampaignList();
  const allCampaigns = campaignList.filter(campaign => campaign.admin_status === "0");

  const filteredCampaignList = useFilterCampaign(selectedCategory);

   useEffect(() => {
    if (selectedCategory) {
      setFilteredCampaigns(filteredCampaignList);
    }
  }, [filteredCampaignList, selectedCategory]);


  const displayedCampaigns = selectedCategory ? filteredCampaigns : allCampaigns;

  const handleCategorySelect = (categoryID) => {
    setSelectedCategory(categoryID); 
    closeModal()
  };

  const handleSearchCampaign = (event) => {
    setSearchCampaign(event.target.value);
  };

  const clearFilter = () => {
    setSelectedCategory(null);
  }


  const campaignImageURL = "https://mosquepay.org/mosquepaynew/assets/img/campaigns/";
  const categoryList = useCampaignCategories();


  return (
    <div className="grid gap-4">
      <Spinner loading={useSelector((state) => state.user).loading} />
      <p className="font-semibold text-sm ubuntu-font">Causes you can donate to:</p>
    <div className="grid md:flex gap-4 items-end">
      <div className="w-full md:w-1/2 lg:w-1/3">
        <Input
          type={"search"}
          label={"Search campaign"}
          placeholder={"Enter campaign name..."}
          value={searchCampaign}
          onChange={handleSearchCampaign}
        />
      </div>
      <div className="">
        <Button
          buttonText={"Filter campaigns"}
          buttonRole={"custom"}
          onClick={openModal}
          otherStyles={"border text-black bg-gray-50 hover:bg-gray-100 transition-all w-fit"}
          icon={filter}
        />
      </div>
    </div>

    {selectedCategory && (
    <p className="text-sm flex divide-x cursor-default w-fit">
      <span className="pr-4">Campaign category: <span className="text-brandGreen">{categoryList.find(cat => cat.needy_category_id === selectedCategory)?.category}</span></span>
      <span onClick={clearFilter} className="cursor-pointer pl-4 hover:text-rose-500">Clear filter</span>
    </p>
    )}

    {/* Campaign Cards */}
    { displayedCampaigns.length === 0 ? 
    <div className="mt-10"> There are no campaigns under this category </div>
    :
    <div className={`grid ${cardLayout} gap-x-4 gap-y-10`}>
      {displayedCampaigns
      .filter((row) => row.title.toLowerCase().includes(searchCampaign.toLowerCase()) || row.lastname.toLowerCase().includes(searchCampaign.toLowerCase()))
      .map((row, index) => {
        const formattedAmountRaised = row?.amount_raise?.replace(/,/g, "");
        const formattedAmount = row?.amount?.replace(/,/g, "");

        const progress =
          formattedAmount > 0
            ? `${((formattedAmountRaised || 0) / formattedAmount) * 100}%`
            : "0%";
        return (
          <div key={index} className="">
            <CampaignCard
              campaignImage={campaignImageURL + (row?.image)}
              campaignID={row?.CampaignID}
              campaignTitle={row?.title}
              campaignOwnerFirstName={row?.firstname}
              campaignOwnerLastName={row?.lastname}
              amountRaised={row?.amount_raise}
              campaignGoal={row?.amount}
              category={row?.category}
              progress={progress}
            />
          </div>
        );
      })}
    </div>
    }
    
    {/* Filter Modal */}
    {isModalOpen && (
      <div className="bg-black/50 h-screen w-full top-0 right-0 left-0 z-50 fixed p-4 flex items-center justify-center">
        <div className="bg-white w-full md:w-[60%] lg:w-[50%] rounded max-h-[80%] overflow-auto">
          <div className="flex justify-between items-center border-b p-5">
            <span className="font-medium">Campaign categories</span>
            <span onClick={closeModal}><img src={close} className="h-4 cursor-pointer" alt="" /></span>
          </div>
          <div className="p-5">
            <div className="flex flex-wrap gap-2 text-sm">
              {categoryList.map((row, index) => (
                <div
                  key={index}
                  className={`p-3 rounded border cursor-pointer ${selectedCategory === row.needy_category_id ? 'bg-brandGreen/10 text-brandGreen border-brandGreen/50' : ''}`}
                  onClick={() => handleCategorySelect(row.needy_category_id)}
                >
                  {row.category}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    )}

  </div>
  );
}
export default CampaignList;